<template>
  <article class="media hand" @click="selData(1)">
    <div class="media-left">
      <div class="has-background-primary has-text-white has-text-centered numero">{{numberreg}}</div>
    </div>
    <div class="media-content">
      <span v-show="reg.tCuenta"
        class="textcuenta fontMono"
        v-bind:class="active(index,selcolumn.columncuenta)"
      >{{codigoCuenta}}</span>
      <strong v-show="reg.tCuenta" v-bind:class="active(index,selcolumn.columncuenta)">{{nombreCuenta}}</strong>
      <strong v-show="reg.tNit" class="fontMono gris" v-bind:class="active(index,selcolumn.columnnit)">{{codigoNit  | textnumber(0)}}{{codigoNit | dverif()}}</strong>
      <strong v-show="reg.tNit" class="gris" v-bind:class="active(index,selcolumn.columnnit)">{{nombreNit}}</strong>
      <br />
      <span v-if="reg.tProducto" class="fontMono" v-bind:class="active(index,selcolumn.columnproducto)">{{codigoproducto}}</span>
      <span v-if="reg.tProducto" class="textcuenta fontMono" v-bind:class="active(index,selcolumn.columnproducto)">{{nombreproducto}}</span>
      <span v-if="reg.tProducto" class=" fontMono">|</span>
      <span v-if="reg.tProducto" class="fontMono" v-bind:class="active(index,selcolumn.columncantidad)"> {{cantidad | number(2)}}</span>
      <span v-if="reg.tProducto" class="textcuenta fontMono">&nbsp;x&nbsp;</span>
      <span v-if="reg.tProducto" class="fontMono" v-bind:class="active(index,selcolumn.columnpunitario)"> ${{punitario | number(2)}}</span>
      <span v-if="reg.tProducto" class="fontMono" v-bind:class="active(index,selcolumn.columnbodega)">| Bodega {{codigobodega}} {{nombrebodega}}</span>
      <br v-if="reg.tProducto">
      <span v-show="reg.tDescripcion" v-bind:class="active(index,selcolumn.columndescripcion)">{{descripcionReg}}</span>
      <br />
      <small>
        <span v-show="reg.tDocref" v-bind:class="active(index,selcolumn.columndocRef)">Documento Referencia:</span>
        <strong v-show="reg.tDocref" class="fontMono" v-bind:class="active(index,selcolumn.columndocRef)">{{docRef}}</strong>
        <span v-show="reg.tCcosto" v-bind:class="active(index,selcolumn.columnccostos)">CCostos:</span>

        <span v-show="reg.tCcosto" class="fontMono" v-bind:class="active(index,selcolumn.columnccostos)">{{ccostos}}</span>
        <span v-show="reg.tCcosto" v-bind:class="active(index,selcolumn.columnccostos)">{{nombreCentroCostos}}</span>
        <span v-show="reg.tBase" v-bind:class="active(index,selcolumn.columnBase)">Base:</span>
        <span v-show="reg.tBase" class="fontMono" v-bind:class="active(index,selcolumn.columnBase)">{{base | number(0)}}</span>
      </small>
    </div>
    <div class="media-right fontMono" v-bind:class="active(index,selcolumn.columnValor)"><span v-show="reg.tipo1  === '-'">-</span>{{valor | number(2)}}</div>
  </article>
</template>

<script>
export default {
  computed: {
    numberreg() {
      if (this.reg.esTotal) {
        return "T";
      } else {
        return this.index + 1;
      }
    },
    codigoCuenta() {
      if (this.reg.cuenta) {
        return this.reg.cuenta;
      } else {
        return "xxxxxx";
      }
    },
    nombreCuenta() {
      if (this.reg.nombreCuenta) {
        return this.reg.nombreCuenta;
      } else {
        return "Nombre del concepto";
      }
    },
    codigoNit() {
      if (this.reg.nit) {
        return this.reg.nit;
      } else {
        return "xxx.xxx.xxx-x";
      }
    },
    nombreNit() {
      if (this.reg.nombreNit) {
        return this.reg.nombreNit;
      } else {
        return "Nombre del tercero, empresa o persona";
      }
    },
    descripcionReg() {
      if (this.reg.descripcion) {
        return this.reg.descripcion;
        } else {
        return "Despcipción con el detalle de la transacción";
      }
    },
    nombreCentroCostos() {
      if (this.reg.nombreCcostos) {
        return this.reg.nombreCcostos;
        } else {
        return "Nombre del centro de costos";
      }
    },
    docRef(){
      if(this.reg.docRef){
        return this.reg.docRef;
      }else {
        return 'xx';
      }
    },
    ccostos(){
      if(this.reg.ccostos){
        return this.reg.ccostos;
      }else {
        return 'xx';
      }
    },
    base(){
      if(this.reg.base){
        return this.reg.base;
      }else {
        return 0;
      }
    },
    valor(){
      if(this.reg.valor){
        return this.reg.valor;
      } else {
        return 0;
      }
    },
    codigoproducto(){
      if(this.reg.nproducto){
        return this.reg.nproducto;
      }else {
        return 'xx';
      }
    },
    nombreproducto(){
      if(this.reg.nombreproducto){
        return this.reg.nombreproducto;
      }else {
        return 'Nombre del producto';
      }
    },
    cantidad(){
      if(this.reg.cantidad){
        return this.reg.cantidad;
      } else {
        return 0;
      }
    },
    punitario(){
      if(this.reg.vlrUnitario){
        return this.reg.vlrUnitario;
      } else {
        return 0;
      }
    },
    codigobodega(){
      if(this.reg.nbodega){
        return this.reg.nbodega;
      }else {
        return 'xx';
      }
    },
    nombrebodega(){
      if(this.reg.nombrebodega){
        return this.reg.nombrebodega;
      }else {
        return 'Nombre de la bodega';
      }
    }
  },
  props: {
    index: Number,
    fila: Number,
    columna: Number,
    selection: Array,
    reg: Object,
    selcolumn: Object
  },
  methods: {
    active(f, c) {
      if (c === this.columna && f === this.fila) {
        return {
          "is-select": true
        };
      } else {
        if(!this.reg[this.selection[c-1].valida]){
          return {
            "is-error": true
          };
        }
      }
    },
    selData(c) {
      this.$emit("columna", c);
      this.$emit("fila", this.index);
    }
  }
};
</script>

<style lang="scss" scoped>
.numero {
  font-size: 14px;
  padding-top: 3px;
  padding-bottom: 3px;
  width: 27px;
  border-radius: 20px;
}
.gris {
  color: #7a7a7a;
}
.textcuenta {
  font-weight: bold;
}
.is-select {
  color: #00d1b2;
  font-size: 23px;
}
.is-error {
  color: #ff3860;
}
</style>





// WEBPACK FOOTER //
// src/components/registrar/Viewregistro.vue